<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100">
                <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
                    <label class="d-flex align-items-center">
                        <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate"
                               class="form-control"
                               [(ngModel)]="searchKeyword"/>
                    </label>
                </div>
                <div class="float-right">
                    <div class="mr-075" [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
                        <label class="d-flex align-items-center" *ngIf="config.selectLimitItems">{{"SHOW" | translate}}
                            <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                    </div>
                    <a class="btn btn-outline-primary text-primary"
                       (click)="modalOpen(modalEducationAdd, null)"
                       *ngIf="_authenticationService.hasCapability('create_education')">{{'ADD' | translate}}</a>
                </div>
                <div class="clearboth"></div>
            </div>

            <!--desktop-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [rowHeight]="config.rowHeight" [limit]="tableLimit" [footerHeight]="config.footerHeight"
                               [rows]="educationSubjectList()">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [sortable]="col.sortable || false" [width]="col.width">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row[col.value] }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                <button class="bg-transparent border-0 text-secondary pr-1"
                                        *ngIf="_authenticationService.hasCapability('edit_education')"
                                        (click)="modalOpen(modalEducationEdit, row)">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                                <button (click)="deleteEducationSubject(row)" *ngIf="_authenticationService.hasCapability('delete_education')"
                                        class="bg-transparent border-0 text-danger remove-item">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile - tablet-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [rowHeight]="config.rowHeight" [limit]="tableLimit" [footerHeight]="config.footerHeight"
                               [rows]="educationSubjectList()">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [width]="col.width || null"
                                          [sortable]="col.sortable || false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile align-items-center">
                                <div class="col-10">
                                    <span>{{ row[col.value] }}</span>
                                </div>
                                <div class="col-2">
                                    <div>
                                        <button class="bg-transparent border-0 text-secondary pr-1"
                                                *ngIf="_authenticationService.hasCapability('edit_education')"
                                                (click)="modalOpen(modalEducationEdit, row)">
                                            <i [data-feather]="'edit-2'" size="19"></i>
                                        </button>
                                        <button (click)="deleteEducationSubject(row)" *ngIf="_authenticationService.hasCapability('delete_education')"
                                                class="bg-transparent border-0 text-danger remove-item">
                                            <i [data-feather]="'trash-2'" size="19"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

        </core-card>
    </div>
</div>


<!-- Modal Edit -->
<ng-template #modalEducationEdit let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"EDIT" | translate}} {{"SCHOOL" | translate}}</h3>
        <label [for]="'editEducationSubject'">{{"SCHOOL" | translate}}<sup class="text-danger">*</sup></label>
        <input name="editEducationSubject" [(ngModel)]="currentEducationSubject.name" type="text" [id]="'editEducationSubject'"
               class="form-control"/>
        <div class="font-error"
             *ngIf="showModalError && (!currentEducationSubject.name || currentEducationSubject.name.length < 1)">{{ 'ERRORS.INSERT_EDUCATION_SCHOOL' | translate }}</div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150"
                (click)="modal.close()"
                rippleEffect>
            {{"ALERT.BTN_CANCEL" | translate}}
        </button>
        <button (click)="editEducationSubject()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{"EDIT" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalEducationAdd let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"ADD" | translate}} {{"SCHOOL" | translate}}</h3>
        <label [for]="'newEducationSubject'">{{"SCHOOL" | translate}}<sup class="text-danger">*</sup></label>
        <input name="newEducationSubject" [(ngModel)]="newEducationSubject" type="text" [id]="'newEducationSubject'" class="form-control"/>
        <div class="font-error"
             *ngIf="showModalError && (!newEducationSubject || newEducationSubject.length < 1)">{{ 'ERRORS.INSERT_EDUCATION_SCHOOL' | translate }}</div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150"
                (click)="modal.close()"
                rippleEffect>
            {{"ALERT.BTN_CANCEL" | translate}}
        </button>
        <button (click)="addEducationSubject()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{"SEND" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal Add -->

